// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Agreement } from '../_models/agreement.model';

export enum AgreementActionTypes {
  AllAgreementsRequested = '[Agreements Home Page] All Agreements Requested',
  AllAgreementsLoaded = '[Agreements API] All Agreements Loaded',
  AgreementOnServerCreated = '[Edit Agreement Dialog] Agreement On Server Created',
  AgreementCreated = '[Edit Agreements Dialog] Agreements Created',
  AgreementReminded = '[Agreements List Page] Agreements Reminded',
  AgreementRevoked = '[Agreements List Page] Agreement Revoked',
  AgreementOnServerUpdated = '[Edit Agreement Dialog] Agreement On Server Updated',
  AgreementUpdated = '[Edit Agreement Dialog] Agreement Updated',
  AgreementOnServerDeleted = '[Agreements List Page] Agreement On Server Deleted',
  AgreementDeleted = '[Agreements List Page] Agreement Deleted',
  AgreementsOnServerDeleted = '[Agreements List Page] Agreements On Server Deleted',
  AgreementsDeleted = '[Agreements List Page] Agreements Deleted',
  AgreementsPageRequested = '[Agreements List Page] Agreements Page Requested',
  AgreementReminderRequested = '[Agreements List Page] Agreement Reminder Requested',
  RevokeAgreementRequested = '[Agreements List Page] Revoke Agreement Requested',
  AgreementsPageLoaded = '[Agreements API] Agreements Page Loaded',
  AgreementsPageCancelled = '[Agreements API] Agreements Page Cancelled',
  AgreementsPageToggleLoading = '[Agreements page] Agreements Page Toggle Loading',
  AgreementsActionToggleLoading = '[Agreements] Agreements Action Toggle Loading',
  ThrowAgreementError = '[Agreements] Throw Agreement Error',
  FireAgreementSuccess = '[Agreements] Fire Success',
}

export class AgreementOnServerCreated implements Action {
  readonly type = AgreementActionTypes.AgreementOnServerCreated;
  constructor(public payload: { agreement: Agreement }) {}
}

export class AgreementCreated implements Action {
  readonly type = AgreementActionTypes.AgreementCreated;
  constructor(public payload: { agreement: Agreement }) {}
}

export class AgreementReminded implements Action {
  readonly type = AgreementActionTypes.AgreementReminded;
  constructor(public payload: { agreement: Agreement }) {}
}

export class AgreementRevoked implements Action {
  readonly type = AgreementActionTypes.AgreementRevoked;
  constructor(public payload: { agreement: Agreement }) {}
}

export class AgreementOnServerUpdated implements Action {
  readonly type = AgreementActionTypes.AgreementOnServerUpdated;
  constructor(
    public payload: {
      partialagreement: Update<Agreement>;
      agreement: Agreement;
    },
  ) {}
}

export class AgreementUpdated implements Action {
  readonly type = AgreementActionTypes.AgreementUpdated;
  constructor(
    public payload: {
      partialagreement: Update<Agreement>;
      agreement: Agreement;
    },
  ) {}
}

export class AgreementOnServerDeleted implements Action {
  readonly type = AgreementActionTypes.AgreementOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class AgreementDeleted implements Action {
  readonly type = AgreementActionTypes.AgreementDeleted;
  constructor(public payload: { id: number }) {}
}

export class AgreementsOnServerDeleted implements Action {
  readonly type = AgreementActionTypes.AgreementsOnServerDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class AgreementsDeleted implements Action {
  readonly type = AgreementActionTypes.AgreementsDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class AgreementsPageRequested implements Action {
  readonly type = AgreementActionTypes.AgreementsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class AgreementReminderRequested implements Action {
  readonly type = AgreementActionTypes.AgreementReminderRequested;
  constructor(public payload: { agreement: Agreement }) {}
}

export class RevokeAgreementRequested implements Action {
  readonly type = AgreementActionTypes.RevokeAgreementRequested;
  constructor(public payload: { agreement: Agreement; reason: string }) {}
}

export class AgreementsPageLoaded implements Action {
  readonly type = AgreementActionTypes.AgreementsPageLoaded;
  constructor(public payload: { agreements: Agreement[]; totalCount: number }) {}
}

export class AgreementsPageCancelled implements Action {
  readonly type = AgreementActionTypes.AgreementsPageCancelled;
}

export class AllAgreementsRequested implements Action {
  readonly type = AgreementActionTypes.AllAgreementsRequested;
}

export class AllAgreementsLoaded implements Action {
  readonly type = AgreementActionTypes.AllAgreementsLoaded;
  constructor(public payload: { agreements: Agreement[] }) {}
}

export class AgreementsPageToggleLoading implements Action {
  readonly type = AgreementActionTypes.AgreementsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class AgreementsActionToggleLoading implements Action {
  readonly type = AgreementActionTypes.AgreementsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowAgreementError implements Action {
  readonly type = AgreementActionTypes.ThrowAgreementError;

  constructor(public payload: { error: any }) {}
}

export class FireAgreementSuccess implements Action {
  readonly type = AgreementActionTypes.FireAgreementSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type AgreementActions =
  | AgreementCreated
  | AgreementUpdated
  | AgreementDeleted
  | AgreementsDeleted
  | AgreementsPageRequested
  | AgreementsPageLoaded
  | AgreementsPageCancelled
  | AllAgreementsLoaded
  | AllAgreementsRequested
  | AgreementOnServerCreated
  | AgreementOnServerUpdated
  | AgreementOnServerDeleted
  | AgreementsOnServerDeleted
  | AgreementsPageToggleLoading
  | AgreementsActionToggleLoading
  | ThrowAgreementError
  | FireAgreementSuccess;
